<template>
    <div>
        <core-form col="1" label-align="left" label-width :editable="true" label-direction="vertical" style="height: 100%; overflow: auto">
    <core-form-item class="pad-face">
      <modifyFace style="width: 100%; max-width: 500px"></modifyFace>
    </core-form-item>
  </core-form>
    </div>
</template>
<script>
import modifyFace from "../../../src/views/personalSetting/modifyFace";
export default {
     components: {
    modifyFace,
  },
}
</script>
<style lang="scss" >
.pad-face{
    .core__item_content{
        justify-content: center;
}
}
</style>